module.exports = __webpack_public_path__ + "static/media/06.2fe3b814.webp";